export default {
  templatesPerTeam: {},
  checklistsPerTeam: {},
  gwPerId: {},
};
